import { ADMIN, ifyouApi } from 'apis/config';
import ErrorMessage from 'apis/ErrorMessage';

interface IDateProp {
  search_start_date?: string;
  search_end_date?: string;
}
interface IProps {
  searchDate?: IDateProp;
  searchWord?: Array<string>;
  inqueryId?: string | number;
  updateData: Array<string>;
}

export const contactUsList = async (searchDate, searchWord: IProps) => {
  try {
    const res = await ifyouApi.post(`${ADMIN}/inquery-list`, {
      search_start_date: searchDate.search_start_date,
      search_end_date: searchDate.search_end_date,
      search_word: searchWord,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const contactUsDetail = async (inqueryId) => {
  try {
    const res = await ifyouApi.post(`${ADMIN}/inquery-detail`, {
      inquiry_no: inqueryId,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};
export const contactUsUpdate = async (updateData) => {
  try {
    const res = await ifyouApi.post(`${ADMIN}/inquery-update`, {
      inquiry_no: updateData.inquiry_no,
      state: updateData.state,
      memo: updateData.memo,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const contactUsDelete = async (inquiryId) => {
  try {
    const res = await ifyouApi.post(`${ADMIN}/inquery-delete`, {
      inquiry_no: inquiryId,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};
